export default __webpack_public_path__ + "static/media/de.db68b7af.png";